import React, { Component } from "react";
import { connect } from "react-redux";
import { translate } from "react-multi-lang";
import "react-datepicker/dist/react-datepicker.css";

import {
    authenticate_adhar_detail,
    verify_adhar_detail,
} from "../../../actions/jobseekerAction";
import store from "../../../store";
import Sidebar from "./Sidebar";
import ServerSetting from "../../../config.json";
import SimpleReactValidator from "simple-react-validator";
import { Link } from "react-router";
import "react-widgets/dist/css/react-widgets.css";

class VerifyAdhar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            Profile: {
                fullname: "",
                adhar_no: "",
                gender: "",
                aadhaarConsent: false,
            },
            showMaskedAadhaar: true,
            // aadhaarMasked: "",
            logId: "",
            Physical: [],
            Addresses: [],

            ResumeSerivice: [],
            Regenerateresume: false,
            selectedResume: "1",
            printProfilePic: "1",
            Education: [],
            sundirectoryload: false,
            disability: "0",
            formData: [],
            profileSubmitted: true,
            Experience: [],
            skill: [],
            error: "",
            errorGender: "",
            requiredPref: false,
            profileCompleted: false,
            edit: false,
            multiSelect: [],
            data: [],
            still_working: "2",
            errorDateFrom: "",
            errorDateTo: "",
            errorDoc: "",
            errorDisableCertificate: "",
            errorVideo: "",
            dobError: "",
            submitted: true,
            submitStatus: true,
            delOption: "",
            delIndex: "",
            submitted2: true,
            submitted1: true,
            physicalTabStatus: false,
            expTabStatus: false,
            addressTabStatus: false,
            eduTabStatus: true,
            submitPhysical: true,
            expUpdated: true,
            expUpdated1: false,
            profileFieldsSet1: false,
            profileFieldsSet2: true,
            profileFieldsSet3: false,
            profileFieldsSet4: true,
            addressFieldSet1: false,
            addressFieldSet2: true,
            deletedAddress: true,
            deletedProfile: true,
            deletedProfile1: true,
            imgSrc: "",
            loginid: "",
        };
        this.education = React.createRef();
        this.experience = React.createRef();
        this.skills = React.createRef();
        this.institue = React.createRef();
        this.certificateRef = React.createRef();
        this.allowedDocFormats = [
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ];
        this.profileValidator = new SimpleReactValidator({
            element: (message) => <div role="alert"
                aria-live="assertive" className="errorclr redcolrs ertet">{message}</div>,
        });

        this.profileValidator = new SimpleReactValidator({
            element: (message) => <div role="alert"
                aria-live="assertive" className="errorclr redcolrs ertet">{message}</div>,
            validators: {
                checkboxRequired: { // custom rule
                    message: 'You must agree to the Aadhaar consent before proceeding.',
                    rule: (val) => val === true,
                },
            },
        });

        this.handleProfileInput = this.handleProfileInput.bind(this);
    }

    componentWillUnmount() {
    }

    // componentDidMount() {
    //     $('#autheticationModalCenter').modal('show');
    // }

    // componentDidMount() {
    //     document.title = this.props.t("header.seekerProfile", { param: "react" });
    //     if (localStorage.getItem("interest") === "1") {
    //         window.$("#jobModal").modal("hide");
    //     }
    //     if (localStorage.getItem("interest") === "2") {
    //         window.$("#jobModal").modal("hide");
    //     }
    //     if (localStorage.getItem("interest") === "null") {
    //         window.$("#jobModal").modal("show");
    //     }
    // }

    checkForSubmittedForm = () => {
        const tabs = [
            {
                name: this.props.t("profileDetails.personalInfo", { param: "react" }),
                value: this.state.profileSubmitted,
            },
            {
                name: this.props.t("profileDetails.communication", { param: "react" }),
                value: this.state.submitStatus,
            },
            {
                name: this.props.t("profileDetails.educationTraning", {
                    param: "react",
                }),
                value: this.state.submitted,
            },
            {
                name: this.props.t("education.additionalEducation", { param: "react" }),
                value: this.state.submitted1,
            },
            {
                name: this.props.t("profileDetails.experience", { param: "react" }),
                value: this.state.submitted2,
            },
            {
                name: this.props.t("profileDetails.physicalAttributes", {
                    param: "react",
                }),
                value: this.state.submitPhysical,
            },
        ];
        tabs.forEach((t) => {
            if (!t.value) {
                store.dispatch(
                    setNotification({
                        type: "warning",
                        message: `You have unsaved changes in ${t.name} Tab`,
                    })
                );
            }
        });
    };

    submitProfile = async () => {
        const { Profile } = this.state;

        // Construct a clean payload with only needed fields
        const payload = {
            auth_key: localStorage.getItem("token"),
            aadhaar: Profile.adhar_no,
            device_id: "DEVICE123456", // Static or dynamically generated
            name: Profile.fullname,
            gender:
                Profile.gender === "1"
                    ? "M"
                    : Profile.gender === "2"
                        ? "F"
                        : Profile.gender === "3"
                            ? "O"
                            : "",
            interface_type: "web",
            consent: Profile.aadhaarConsent ? 1 : 0
        };

        if (this.profileValidator.allValid()) {
            const result = await store.dispatch(verify_adhar_detail(payload));
            if (result.success) {
                localStorage.setItem('aadhaar_masked', result.aadhaar_masked);
                this.setState({
                    // aadhaarMasked: result.aadhaar_masked,
                    logId: result.log_id,
                });
                $('#autheticationModalCenter').modal('show');
            } else {

            }
        } else {
            this.profileValidator.showMessages();
            this.forceUpdate();
        }
    };


    handleProceed = async () => {
        const { Profile, logId } = this.state;

        const payload = {
            auth_key: localStorage.getItem("token"),
            uid: Profile.adhar_no,
            name: Profile.fullname,
            gender:
                Profile.gender === "1"
                    ? "M"
                    : Profile.gender === "2"
                        ? "F"
                        : Profile.gender === "3"
                            ? "O"
                            : "",
            log_id: logId
        };

        const result = await store.dispatch(authenticate_adhar_detail(payload));

        if (result.success) {
            $('#autheticationModalCenter').modal('hide');
            this.props.router.push('/authentication-success')
        } else {
            const failureMessage = result.data?.message || "Authentication failed";
            localStorage.setItem("auth_failure_message", failureMessage);
            this.props.router.push('/authentication-failure')
        }
    };


    submitOnBlur = (e = "", value = "") => {
        if ((e && e.target.value) || value) {
            // this.submitProfile(true)
            this.submitProfile(false, false);
        }
    };

    async handleSubmitProfile() {
        await this.submitProfile();
    }

    onChange = (val) => {
        const Experience = this.state.Experience;
        Experience.key_skills = val;
        this.setState({ Experience });
    };

    async handleProfileInput(e) {
        e.persist();
        const name = e.target.name;
        var value = e.target.value;
        var type = e.target.type;
        let Profile = this.state.Profile;

        // Extract only digits and limit to 12
        const digitsOnly = value.replace(/\D/g, '').slice(0, 12);

        this.setState((prevState) => ({
            Profile: {
                ...prevState.Profile,
                [name]: digitsOnly,
            },
        }));

        if (type === "text") {
            let regex = /^[A-Za-z0-9 ]+$/;
            if (!regex.test(value) && value) {
                return false;
            }
        }
        if (type === "number") {
            if (value.startsWith("0")) {
                value = "";
                e.target.value = "";
            }
        }
        if (name === "prefered_district" && value === "2") {
            this.setState({ requiredPref: true });
        } else if (name === "prefered_district" && value === "1") {
            this.setState({ requiredPref: false });
        }

        const fieldSet1 = ["email", "middlename", "lastname", "adhar_no"];
        if (fieldSet1.includes(name)) {
            if (!value) this.setState({ profileFieldsSet2: false });

            if (value && !Profile[name]) this.setState({ profileFieldsSet1: false });
        }

        const fieldSet2 = ["category", "guardian_phone"];
        if (fieldSet2.includes(name)) {
            if (!value) this.setState({ profileFieldsSet4: false });

            if (value && !Profile[name]) this.setState({ profileFieldsSet3: false });
        }

        Profile[name] = value;

        if (
            name === "prefered_district" &&
            (!value || value === "1") &&
            (Profile.district1 || Profile.district2 || Profile.district3)
        ) {
            Profile["district1"] = "";
            Profile["district2"] = "";
            Profile["district3"] = "";
            this.setState({ requiredPref: false });
        }
        await this.setState({ Profile, profileSubmitted: false });
    }

    // handleProfileInput = (event) => {
    //     const { name, value } = event.target;

    //     // Extract only digits and limit to 12
    //     const digitsOnly = value.replace(/\D/g, '').slice(0, 12);

    //     this.setState((prevState) => ({
    //         Profile: {
    //             ...prevState.Profile,
    //             [name]: digitsOnly,
    //         },
    //     }));
    // };

    maskAadhaarForDisplay = (value) => {

        const digits = value.replace(/\D/g, '');

        if (digits.length < 12) {
            return digits;
        }

        const lastFour = digits.slice(-4);
        return `XXXX XXXX ${lastFour}`;
    };



    render() {
        const {
            requiredPref,
            skill,
            errorSkill,
            edit,
            Education,
            errorCertificate,
            errorDateFrom,
            errorDateTo,
            dobError,
            profileCompleted,
            physicalTabStatus,
            expTabStatus,
            addressTabStatus,
            eduTabStatus,
        } = this.state;
        const SERVER_PATH = ServerSetting[process.env.NODE_ENV].SERVER_PATH;
        let Mainprops = this.props;
        let Mainstate = this.state;
        const {
            comValidator,
            profileValidator,
            expValidator,
            PhysicalValidator,
            eduValidator,
            skillValidator,
        } = this;

        let Mainthis = this;

        //Fetch courses for autocomplete
        let courses = [];
        const educationLevel = this.props.actionReducer.educationLevel;
        if (Education.highest_education_level) {
            const selectedEducation = educationLevel.filter(
                (edu) => edu.education_id === Education.highest_education_level
            );
            if (selectedEducation && selectedEducation[0]) {
                selectedEducation &&
                    selectedEducation[0] &&
                    selectedEducation[0].qualification.forEach((qual) => {
                        courses.push({ label: qual.name, id: qual.id });
                    });
            }
        }

        courses.push({ label: "Others", id: "152" });

        // Date format for datepicker
        const dob = this.state.Profile.dob && this.state.Profile.dob.split("-");
        // const dateFrom = this.state.Experience[0].date_from
        // && this.state.Experience.date_from.split("-")
        // const dateTo = this.state.Experience.date_to && this.state.Experience.date_to.split("-")
        if (localStorage.getItem("Islogin") !== "true") {
            this.props.router.push("/");
        }

        let constituency = [];
        if (
            this.state.Addresses &&
            this.state.Addresses.current &&
            this.state.Addresses.current.district_id
        ) {
            constituency = this.props.actionReducer.constituency.filter(
                (data) => data.district_id === this.state.Addresses.current.district_id
            );
        }

        const genderOptions = [
            { id: '1', name: this.props.t("gender.male") },
            { id: '2', name: this.props.t("gender.female") },
            { id: '3', name: this.props.t("gender.others") }
        ];

        return (
            <section
                className="back-dashboard widget-sidebar-context mt-3"
                id="my-sidebar-context"
            >
                <div className="container">
                    <div className="row">
                        <Link className="navbar-toggler widget-sidebar-toggler text-white">
                            Sidebar
                        </Link>
                        <Sidebar route={Mainprops.route} />
                        <main className="col col-md-9 second-side ps-4 pb-3 h-100">
                            <div className="panel-heading">
                                <h6 className="mb-0">
                                    {this.props.t("verifyAdhar.adhar_title", {
                                        param: "react",
                                    })}
                                </h6>
                            </div>

                            <div className="tab-content profile-page mainverify">
                                {/* first div */}
                                <div className="row m-0">
                                    <div className="col-lg-6 m-0 p-0">
                                        <div className="panel-body m-3">
                                            <div className="verify-adhar-div">
                                                <h5 className="verify-adhar-headings mt-0">
                                                    <span className="me-2">🔐</span> {this.props.t("verifyAdhar.adhar_title", {
                                                        param: "react",
                                                    })}
                                                </h5>
                                                <div className="verify-adhar-content">
                                                    <li>
                                                        <span>●</span>
                                                        {this.props.t("verifyAdhar.adhar_cons1", {
                                                            param: "react",
                                                        })}.
                                                    </li>
                                                    <li>
                                                        <span>●</span>
                                                        {this.props.t("verifyAdhar.adhar_cons2", {
                                                            param: "react",
                                                        })}.
                                                    </li>
                                                    <li>
                                                        <span>●</span>
                                                        {this.props.t("verifyAdhar.adhar_cons3", {
                                                            param: "react",
                                                        })}.
                                                    </li>
                                                    <li>
                                                        <span>●</span>
                                                        {this.props.t("verifyAdhar.adhar_cons4", {
                                                            param: "react",
                                                        })}.
                                                    </li>
                                                    <li>
                                                        <span>●</span>
                                                        {this.props.t("verifyAdhar.adhar_cons5", {
                                                            param: "react",
                                                        })}.
                                                    </li>
                                                </div>
                                            </div>

                                            <div className="titilesize">
                                                <h5 className="verify-adhar-headings">
                                                    <span className="me-2"> 📝</span> {this.props.t("verifyAdhar.inst_form1", {
                                                        param: "react",
                                                    })}
                                                </h5>

                                                <div className="verify-adhar-content">
                                                    <li className="verify-adhar-title">  <span>●</span>{this.props.t("verifyAdhar.inst_form_lbl1", {
                                                        param: "react",
                                                    })}</li>
                                                    <ul>
                                                        {" "}
                                                        {this.props.t("verifyAdhar.inst_form2", {
                                                            param: "react",
                                                        })}
                                                        . <br />✅ “Monu Kumar” ❌ “M. Kumar”
                                                    </ul>
                                                    <li className="verify-adhar-title">  <span>●</span>{this.props.t("verifyAdhar.inst_form_lbl2", {
                                                        param: "react",
                                                    })}</li>
                                                    <ul>
                                                        {" "}
                                                        {this.props.t("verifyAdhar.inst_form3", {
                                                            param: "react",
                                                        })}{" "}
                                                        <span className="verify-adhar-bold">
                                                            {this.props.t("verifyAdhar.inst_form4", {
                                                                param: "react",
                                                            })}
                                                        </span>{" "}
                                                        {this.props.t("verifyAdhar.inst_form5", {
                                                            param: "react",
                                                        })}.
                                                        <br />
                                                        {this.props.t("verifyAdhar.inst_form6", {
                                                            param: "react",
                                                        })}.
                                                    </ul>

                                                    <li className="verify-adhar-title">  <span>●</span>{this.props.t("verifyAdhar.inst_form_lbl3", {
                                                        param: "react",
                                                    })}</li>
                                                    <ul>
                                                        {" "}
                                                        {this.props.t("verifyAdhar.inst_form7", {
                                                            param: "react",
                                                        })}. <br />
                                                        {this.props.t("verifyAdhar.inst_form11", {
                                                            param: "react",
                                                        })}
                                                        .
                                                    </ul>

                                                    <li className="verify-adhar-title">  <span>●</span>{this.props.t("verifyAdhar.inst_form_lbl4", {
                                                        param: "react",
                                                    })}</li>
                                                    <ul>
                                                        {this.props.t("verifyAdhar.inst_form8", {
                                                            param: "react",
                                                        })}
                                                        <br />
                                                        <span className="verify-adhar-bold">
                                                            {this.props.t("verifyAdhar.inst_form9", {
                                                                param: "react",
                                                            })}
                                                        </span>{" "}
                                                        {this.props.t("verifyAdhar.inst_form10", {
                                                            param: "react",
                                                        })}

                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Border */}
                                    {/* <div className="d-none d-md-block col-md-0 px-0">
                                        <div className="verify-adhar-border-vertical"></div>
                                    </div> */}
                                    {/* 
                                    <div className="d-block d-md-none col-12">
                                        <div className="verify-adhar-border-horizontal my-3"></div>
                                    </div> */}


                                    {/* sec div */}
                                    <div className="col-lg-6 m-0 p-0">
                                        <div
                                            className="panel-body m-3 htsetup"

                                        >
                                            <h6 className="verify-adhar-bold mt-2">
                                                {this.props.t("verifyAdhar.cons_form_title", {
                                                    param: "react",
                                                })}
                                            </h6>



                                            <form className="h-100"
                                                onSubmit={(event) => {
                                                    event.preventDefault();
                                                    this.handleSubmitProfile(event);
                                                }}
                                            >
                                                <div className="panel-body p-0 m-0 fullboxinline">

                                                    <div className="w-100">

                                                        {/* Row 1: Full Name */}
                                                        <div
                                                            className="flexboxadhcard"

                                                        >
                                                            <div className="flexboxadh1">
                                                                <label
                                                                    htmlFor="fullname"
                                                                    title={this.props.t("verifyAdhar.full_name", {
                                                                        param: "react",
                                                                    })}
                                                                    className="adhar-form-label"
                                                                >
                                                                    {this.props.t("verifyAdhar.full_name", {
                                                                        param: "react",
                                                                    })}
                                                                    <span className="errorclr ml-2">*</span>
                                                                </label>
                                                                <label className="smtilte"> ({this.props.t("verifyAdhar.adhar_guide", {
                                                                    param: "react",
                                                                })})</label>
                                                            </div>
                                                            <div className="flexboxadh">
                                                                <input
                                                                    autoComplete="fullname"
                                                                    type="text"
                                                                    className="form-control w-100"
                                                                    id="fullname"
                                                                    name="fullname"
                                                                    aria-label="Enter full name"
                                                                    aria-required="true"
                                                                    value={this.state.Profile.fullname || ""}
                                                                    onChange={(event) =>
                                                                        Mainthis.handleProfileInput(event)
                                                                    }
                                                                    placeholder={
                                                                        this.props.t("placeholder.enter", {
                                                                            param: "react",
                                                                        }) +
                                                                        " " +
                                                                        this.props.t("verifyAdhar.full_name", {
                                                                            param: "react",
                                                                        })
                                                                    }
                                                                />
                                                                <label className="text-danger">
                                                                    {profileValidator.message(
                                                                        "fullname",
                                                                        this.state.Profile.fullname,
                                                                        "required|min:3|max:50|regex:^[A-Za-z ]+$"
                                                                    )}
                                                                </label>
                                                            </div>
                                                        </div>

                                                        {/* Row 2: Aadhaar Number */}
                                                        <div
                                                            className="flexboxadhcard"

                                                        >
                                                            <div className="flexboxadh1">
                                                                <label
                                                                    htmlFor="adhar_no"
                                                                    title="Please enter Aadhaar number"
                                                                    className="adhar-form-label"
                                                                >
                                                                    {this.props.t("verifyAdhar.adhar_no", {
                                                                        param: "react",
                                                                    })}
                                                                    <span className="errorclr ml-2">*</span>
                                                                </label>
                                                                <label className="smtilte">({this.props.t("verifyAdhar.digit", {
                                                                    param: "react",
                                                                })})</label>
                                                            </div>
                                                            <div className="flexboxadh">
                                                                <input
                                                                    autoComplete="adhar-number"
                                                                    type="text"
                                                                    maxLength={12}
                                                                    className="form-control w-100"
                                                                    id="adhar_no"
                                                                    name="adhar_no"
                                                                    aria-label="Enter adhar number"
                                                                    aria-required="true"
                                                                    value={this.maskAadhaarForDisplay(this.state.Profile.adhar_no || "")}
                                                                    onChange={this.handleProfileInput}
                                                                    placeholder={
                                                                        this.props.t("verifyAdhar.adhar_placeholder", {
                                                                            param: "react",
                                                                        })
                                                                    }
                                                                />
                                                                <label className="text-danger">
                                                                    {this.profileValidator.message(
                                                                        "adhar_no",
                                                                        this.state.Profile.adhar_no,
                                                                        "required|numeric|min:12|max:12"
                                                                    )}
                                                                </label>
                                                            </div>
                                                        </div>

                                                        {/* Row 3: Gender */}
                                                        <div className="flexboxadhcard">
                                                            <div className="flexboxadh1 mt-1">
                                                                <label
                                                                    htmlFor="gender"
                                                                    title={this.props.t(
                                                                        "profileDetails.genderDesc",
                                                                        { param: "react" }
                                                                    )}
                                                                    className="adhar-form-label"
                                                                >
                                                                    {this.props.t("profileDetails.gender", {
                                                                        param: "react",
                                                                    })}
                                                                    <span className="errorclr ml-2">*</span>
                                                                </label>

                                                            </div>
                                                            <div className="w-100">
                                                                <div className="flexboxadh ghf" >
                                                                    {genderOptions.map((data, index) => (
                                                                        <div className="form-check form-check-inline" key={index}>
                                                                            <input
                                                                                style={{ transform: 'scale(0.8)' }}
                                                                                type="radio"
                                                                                className="form-check-input"
                                                                                id={`gender-${data.id}`}
                                                                                name="gender"
                                                                                aria-label="Enter gender"
                                                                                value={data.id}
                                                                                checked={this.state.Profile.gender === data.id}
                                                                                onChange={this.handleProfileInput}
                                                                                aria-required="true"
                                                                            />
                                                                            <label className="form-check-label" htmlFor={`gender-${data.id}`}>
                                                                                {data.name}
                                                                            </label>
                                                                        </div>
                                                                    ))}

                                                                </div>
                                                                <label className="text-danger">
                                                                    {this.profileValidator.message(
                                                                        "gender",
                                                                        this.state.Profile.gender,
                                                                        "required"
                                                                    )}
                                                                </label>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <div className="w-100">

                                                        {/* checkbox */}
                                                        <div className="forcheckbox mt-4">
                                                            <div className="forcheck">
                                                                <div className="form-check p-0">
                                                                    <label
                                                                        className="form-check-label m-0 flein"
                                                                        htmlFor="aadhaarConsent"
                                                                    >
                                                                        <input
                                                                            className="form-check-input m-0"
                                                                            type="checkbox"
                                                                            id="aadhaarConsent"
                                                                            name="aadhaarConsent"
                                                                            aria-label="Check aadhaar consent"
                                                                            checked={
                                                                                this.state.Profile.aadhaarConsent
                                                                            }
                                                                            onChange={(event) =>
                                                                                Mainthis.setState({
                                                                                    Profile: {
                                                                                        ...this.state.Profile,
                                                                                        aadhaarConsent: event.target.checked,
                                                                                    },
                                                                                })
                                                                            }
                                                                        />
                                                                        {this.props.t("verifyAdhar.verfication_txt", {
                                                                            param: "react",
                                                                        })}
                                                                        .
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <label className="text-danger">
                                                                {this.profileValidator.message(
                                                                    "aadhaarConsent",
                                                                    this.state.Profile.aadhaarConsent,
                                                                    "checkboxRequired"
                                                                )}
                                                            </label>
                                                        </div>

                                                        {/* Submit Button*/}
                                                        <div className="flexboxadhcard w-100 mainboxhead">
                                                            <button
                                                                aria-label='Submit Aadhaar Verification Form'
                                                                type="submit"
                                                                className="btn btn-primary btn-primary2 w-100"
                                                            >
                                                                {this.props.t("verifyAdhar.saveButton", {
                                                                    param: "react",
                                                                })}
                                                            </button>
                                                        </div>

                                                        <div className="">
                                                            <p className="clird mt-4 mb-3">
                                                                {this.props.t("verifyAdhar.legal_consent_note", {
                                                                    param: "react",
                                                                })}
                                                            </p>

                                                            <p className="clird">
                                                                {this.props.t("verifyAdhar.privacy_note", {
                                                                    param: "react",
                                                                })}
                                                            </p>
                                                        </div>

                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </main>
                    </div>
                </div>

                {/* Modal */}
                <div class="modal fade authen-main-container" id="autheticationModalCenter" tabindex="-1" data-backdrop="static" data-keyboard="false" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" >
                    <div class="modal-dialog modal-dialog-centered " role="document">
                        <div class="modal-content">
                            <div class="modal-body authetication-text p-4">
                                {this.props.t("verifyAdhar.proceed_submit", {
                                    param: "react",
                                })}.
                            </div>
                            <div class="modal-footer p-4 pt-0">
                                <button
                                    aria-label='Cancel and go back to form'
                                    type="button" class="btn authen-cancel-btn me-3 wdset" data-dismiss="modal"> {this.props.t("verifyAdhar.cancel_btn", {
                                        param: "react",
                                    })}</button>
                                <button
                                    aria-label='Proceed with Aadhaar verification'
                                    type="button" class="btn authen-proceed-btn wdset" onClick={this.handleProceed}> {this.props.t("verifyAdhar.proceed_btn", {
                                        param: "react",
                                    })}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

const mapStateToProps = (store) => {
    return store;
};

export default connect(mapStateToProps)(translate(VerifyAdhar));
